var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionWorldGlobe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-9.963 8h-.074a11.716 11.716 0 0 1-2.317-4h4.708a11.718 11.718 0 0 1-2.317 4Zm-2.714-.459c-.65-.783-1.348-1.928-1.807-3.541H5.07a8.026 8.026 0 0 0 4.253 3.541ZM4.252 14h2.866A16.422 16.422 0 0 1 7 12c0-.718.042-1.384.118-2H4.252A8.015 8.015 0 0 0 4 12c0 .69.088 1.36.252 2Zm.818-6h2.446c.46-1.613 1.157-2.758 1.807-3.541A8.026 8.026 0 0 0 5.07 8Zm6.893-4a11.718 11.718 0 0 0-2.317 4h4.708a11.716 11.716 0 0 0-2.317-4 9.127 9.127 0 0 0-.074 0Zm2.713.459c.65.783 1.348 1.928 1.807 3.541h2.447a8.025 8.025 0 0 0-4.254-3.541Zm0 15.082c.65-.783 1.348-1.928 1.807-3.541h2.447a8.026 8.026 0 0 1-4.254 3.541ZM20 12c0 .69-.087 1.36-.252 2h-2.866c.076-.616.118-1.282.118-2s-.042-1.384-.118-2h2.866c.165.64.252 1.31.252 2Zm-5 0c0 .709-.056 1.375-.154 2H9.154A12.843 12.843 0 0 1 9 12c0-.709.056-1.375.154-2h5.692c.098.625.154 1.291.154 2Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionWorldGlobe);
export default __webpack_public_path__ + "static/media/ic_action_world_globe.442832f03e3448ae41ccdee37529c067.svg";
export { ForwardRef as ReactComponent };